import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import KontaktPage from '../pages/kontakt/page';
import ProjektePage from '../pages/projekte/page';
import LeistungenPage from '../pages/leistungen/page';
import LeistungsgebietePage from '../pages/leistungsgebiete/page';
import UeberUnsPage from '../pages/ueber-uns/page';
import ImpressumPage from '../pages/impressum/page';
import DatenschutzPage from '../pages/datenschutz/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/kontakt',
    element: <KontaktPage />,
  },
  {
    path: '/leistungen',
    element: <LeistungenPage />,
  },
  {
    path: '/projekte',
    element: <ProjektePage />,
  },
  {
    path: '/ueber-uns',
    element: <UeberUnsPage />,
  },
  {
    path: '/leistungsgebiete',
    element: <LeistungsgebietePage />,
  },
  {
    path: '/jobs',
    element: <HomePage />,
  },
  {
    path: '/impressum',
    element: <ImpressumPage />,
  },
  {
    path: '/datenschutz',
    element: <DatenschutzPage />,
  },
  {
    path: '/agb',
    element: <HomePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
